import React from 'react';

const FinanceiroContext = React.createContext();

export default FinanceiroContext;